import { Anchor, Badge, Button, Card, Flex, Grid, Text, Tooltip } from '@mantine/core';
import { IconChartLine, IconHistory, IconPackages } from '@tabler/icons-react';
import { useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router';
import prettifiedLabel from '../../constants/labelPrettifier';
import EmailStats from './EmailStats';

const EmailCard = ({ email, stats, period }) => {
  const currentDomain = useSelector((state) => state.domain.domain);
  const domainCurrency = currentDomain.currency;

  const location = useLocation();
  const { accountId, domainId } = useParams();

  const productFeedsBadges = email.productFeeds?.map((productFeed, index) => (
    <Badge key={index} variant="default">
      <IconPackages size={14} style={{ verticalAlign: 'middle', marginRight: 4 }} />
      <Anchor
        href={`#/accounts/${accountId}/domains/${domainId}/productFeeds/${productFeed.id}/details`}
        target="_blank"
        size="xs"
      >
        {productFeed.name}
      </Anchor>
    </Badge>
  ));

  return (
    <Card key={email.id} mb="md" data-email-name={email.name} withBorder>
      <Card.Section inheritPadding py="sm">
        <Grid>
          <Grid.Col span={{ base: 12, sm: 8 }}>
            <Flex align="center" gap="sm" mb="xs">
              <Anchor href={`#${location.pathname}/${email.id}/details`} fw={600} data-tour="emailCardLink">
                {email.name}
              </Anchor>
              <Text c="dimmed" size="sm">
                {email.subject}
              </Text>
            </Flex>
            <Flex gap="xs" wrap="wrap">
              {email.type !== 'html' && (
                <Badge variant="default">
                  {prettifiedLabel(email.type)} - {prettifiedLabel(email.editor)}
                </Badge>
              )}
              {productFeedsBadges}
              <Tooltip
                label={
                  <>
                    <div>Created: {new Date(email.createdAt).toLocaleString()}</div>
                    <div>Updated: {new Date(email.updatedAt).toLocaleString()}</div>
                  </>
                }
                position="top"
                withArrow
              >
                <Badge variant="default" style={{ cursor: 'pointer' }}>
                  <IconHistory size={14} style={{ verticalAlign: 'middle' }} />
                </Badge>
              </Tooltip>
            </Flex>
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 4 }}>
            <Flex justify="flex-end" align="flex-start">
              <Button component="a" href={`#${location.pathname}/${email.id}/analytics`} size="xs">
                Statistics <IconChartLine size={14} style={{ marginLeft: 4 }} />
              </Button>
            </Flex>
          </Grid.Col>
        </Grid>
      </Card.Section>
      <Card.Section inheritPadding py="sm">
        <Grid>
          <EmailStats email={email} stats={stats} period={period} currency={domainCurrency} />
        </Grid>
      </Card.Section>
    </Card>
  );
};
export default EmailCard;
